import { createSlice } from "@reduxjs/toolkit";

export const menuSlice = createSlice({
  name: "menu",
  initialState: { open: false },
  reducers: {
    setMenuOpen: (state, action) => {
      state.open = action.payload;
    },
  },
});

export const { setMenuOpen } = menuSlice.actions;
export default menuSlice.reducer;
